export default {
  mounted() {
    if (this.$store.state.jwtExpired) {
      this.$message({
        showClose: true,
        message: this.$t("graphQL.errorMessage.jwtExpired"),
        type: "warning",
        duration: 6000, // change display time
      });
      this.$store.commit("jwtExpired", false);
    }
  },
};
